import { render, staticRenderFns } from "./PendingAcceptanceListing.vue?vue&type=template&id=6d5ed95a"
import script from "./PendingAcceptanceListing.vue?vue&type=script&lang=js"
export * from "./PendingAcceptanceListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports